var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--square-grid", style: _vm.styles },
    [
      _c("div", { staticClass: "sk-cube sk-cube1", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube2", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube3", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube4", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube5", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube6", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube7", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube8", style: _vm.cubeStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-cube sk-cube9", style: _vm.cubeStyles }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }